import type { KryspaceRenderManifest, RenderManifestQueueItem } from '../../../types/kryspaceRenderManifest';
import { fixUtf8Mojibake } from '../fixUtf8Mojibake';

export interface ExoPanelCalendarEvent {
  itemId: string;
  title: string;
  scheduledDate: string;
  statusPhrase: string;
  priority?: string;
}

export interface ExoPanelCalendarModel {
  events: ExoPanelCalendarEvent[];
  todayLabel?: string;
}

function rowField(row: RenderManifestQueueItem, key: string): unknown {
  return (row as RenderManifestQueueItem & Record<string, unknown>)[key];
}

/** Manifest-first calendar strip for ExoPanel context bar. */
export function parseExoPanelCalendarFromManifest(
  manifest: KryspaceRenderManifest
): ExoPanelCalendarModel | null {
  const section = manifest.sections.find((s) => s.id === 'exopanel-calendar');
  if (!section?.queue?.length) return null;

  const todayLabel =
    typeof section.meta?.todayLabel === 'string' ? section.meta.todayLabel.slice(0, 10) : undefined;

  const events: ExoPanelCalendarEvent[] = section.queue.map((row) => {
    const itemId =
      (typeof row.itemId === 'string' && row.itemId) ||
      (typeof rowField(row, 'item_id') === 'string' ? (rowField(row, 'item_id') as string) : '');
    const title = fixUtf8Mojibake(
      (typeof row.title === 'string' && row.title) ||
        (typeof rowField(row, 'name') === 'string' ? (rowField(row, 'name') as string) : itemId)
    );
    const scheduledDate =
      (typeof rowField(row, 'scheduledDate') === 'string' &&
        (rowField(row, 'scheduledDate') as string).slice(0, 10)) ||
      (typeof rowField(row, 'scheduled_date') === 'string'
        ? (rowField(row, 'scheduled_date') as string).slice(0, 10)
        : todayLabel ?? manifest.generatedAt.slice(0, 10));
    const statusPhrase = String(
      row.statusPhrase ?? rowField(row, 'status_phrase') ?? 'scheduled'
    ).toLowerCase();
    const priorityRaw = row.priority ?? rowField(row, 'priority');
    const priority = priorityRaw != null && priorityRaw !== '' ? String(priorityRaw) : undefined;

    return { itemId, title, scheduledDate, statusPhrase, priority };
  });

  return { events, todayLabel };
}
